const TextResources = {
    timeline_1: {
        heading: "Initial Consultation",
        description: "We start with a comprehensive review of your business, and consultation to understand your business goals, target audience(s), current marketing strategy, and present performance. Our team will use this information to tailor our services to meet your specific needs."
    },
    timeline_2: {
        heading: "Strategic Planning",
        description: "Based on our consultation, our team will develop a customized plan for you. Whether we’re just building you a website, or are remaking your brand identity, we will compile an easy-to-understand plan to present to you. Everything is ultimately decided by you, and you have complete control to change any aspect of our proposal."
    },
    timeline_3: {
        heading: "Creative Development",
        description: "Our creative team gets to work. Whether we’re designing compelling content, hosting your email servers, or working on graphics for your restaurant menus. We will diligently begin serving you, and keeping you updated with our work along the way."
    },
    timeline_4: {
        heading: "Implementation",
        description: "We’ll be right by your side for your launch. Whether that is your beautiful new website, social media post, marketing strategy, or anything else. Our team will ensure everything runs smoothly and efficiently, keeping you informed throughout the process."
    },
    timeline_5: {
        heading: "Monitoring and Optimization",
        description: "We continuously monitor the performance of our work and your campaigns, analyzing data to identify areas for improvement. This allows us to optimize strategies in real-time for the best possible results, maximizing your return on investment."
    },
    timeline_6: {
        heading: "Reporting and Feedback",
        description: "We stick around, even after the job is done. Regular reports keep you updated on the progress and success of your campaigns. We also value your feedback, which helps us fine-tune our approach and deliver even better results. You can count on us to ensure things continue working as intended."
    },
    timeline_7: {
        heading: "Ongoing Support",
        description: "Our relationship doesn’t end with the campaign or project. We provide ongoing support and updates to ensure your marketing efforts continue to thrive. You can count on us to remain in touch and have your back, well after our services have been delivered. --"
    },
}

export default TextResources;